export function followBtn() {
document.addEventListener("DOMContentLoaded", () => {
	const followBtn = document.querySelector(".l-follow_btn");
	const triggerEl = document.querySelector(".is-follow_btn-view");
	const isTopPage = location.pathname === "/" || location.pathname === "/index.html";
	const isAboutPage = location.pathname === "/about/";

	let lastScrollY = window.scrollY;
	let shouldAlwaysShow = false;

	function showFollowBtn() {
		followBtn?.classList.add("is-visible");
	}

	function hideFollowBtn() {
		followBtn?.classList.remove("is-visible");
	}

	function handleScroll() {
		if (shouldAlwaysShow) return; // 常時表示条件があれば無視
		const currentScroll = window.scrollY;
		const scrollingUp = currentScroll < lastScrollY;
		lastScrollY = currentScroll;

		if (scrollingUp) {
		showFollowBtn();
		} else {
		hideFollowBtn();
		}
	}

	// /about/ は常に表示
	if (isAboutPage) {
		shouldAlwaysShow = true;
		showFollowBtn();
	}

	// TOPページで.is-follow_btn-viewが可視領域に入ったら常時表示
	if (isTopPage && triggerEl) {
		const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
			shouldAlwaysShow = true;
			showFollowBtn();
			} else {
			shouldAlwaysShow = false;
			}
		});
		}, { threshold: 0.2 });
		observer.observe(triggerEl);
	}

	// 上スクロール検知（条件付き）
	window.addEventListener("scroll", handleScroll);
	});

}